export const ProviderIndexerCommon = {
  key: 'indexer',
}

export type ProviderIndexerAccountType = null
